import { useState } from 'react';
import { sendJoinRequestNotificationEmail } from '../lib/api/emailNotifications';
import { resendEmailService } from '../lib/services/resendEmailService';

export default function EmailTest() {
  const [testEmail, setTestEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);

  const testJoinRequestEmail = async () => {
    if (!testEmail) {
      alert('Veuillez entrer un email de test');
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      console.log('🧪 [TEST] Starting join request email test...');
      
      const testData = {
        commissionerEmail: testEmail,
        commissionerUsername: 'Commissaire Test',
        requesterUsername: 'Joueur Test',
        leagueName: 'Ligue Test Dynasty'
      };

      console.log('🧪 [TEST] Test data:', testData);

      const result = await sendJoinRequestNotificationEmail(testData);
      
      console.log('🧪 [TEST] Result:', result);
      setResult(result);

    } catch (error: any) {
      console.error('🧪 [TEST] Error:', error);
      setResult({ success: false, error: error.message || 'Unknown error' });
    } finally {
      setLoading(false);
    }
  };

  const testBrevoService = async () => {
    if (!testEmail) {
      alert('Veuillez entrer un email de test');
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      console.log('🧪 [TEST] Testing Brevo service directly...');
      
      const testData = {
        commissionerEmail: testEmail,
        commissionerUsername: 'Commissaire Test Direct',
        requesterUsername: 'Joueur Test Direct',
        leagueName: 'Ligue Test Direct'
      };

      const result = await resendEmailService.sendJoinRequestNotification(testData);
      
      console.log('🧪 [TEST] Direct Resend result:', result);
      setResult(result);

    } catch (error: any) {
      console.error('🧪 [TEST] Direct Resend error:', error);
      setResult({ success: false, error: error.message || 'Unknown error' });
    } finally {
      setLoading(false);
    }
  };

  const checkConfig = () => {
    console.log('🔍 Checking configuration...');
    console.log('API Key configured:', !!import.meta.env.VITE_RESEND_API_KEY);
    console.log('From Email:', import.meta.env.VITE_FROM_EMAIL);
    console.log('Frontend URL:', import.meta.env.VITE_FRONTEND_URL);
    console.log('Resend service configured:', resendEmailService.isConfigured());
  };

  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-6">
            🧪 Test des Emails de Demande d'Adhésion
          </h1>

          <div className="space-y-6">
            {/* Configuration Check */}
            <div className="bg-blue-50 p-4 rounded-lg">
              <h2 className="text-lg font-semibold text-blue-900 mb-3">Configuration</h2>
              <button
                onClick={checkConfig}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Vérifier la Configuration
              </button>
              <p className="text-sm text-blue-700 mt-2">
                Ouvrez la console pour voir les détails de configuration
              </p>
            </div>

            {/* Email Input */}
            <div>
              <label htmlFor="testEmail" className="block text-sm font-medium text-gray-700 mb-2">
                Email de test
              </label>
              <input
                type="email"
                id="testEmail"
                value={testEmail}
                onChange={(e) => setTestEmail(e.target.value)}
                placeholder="votre@email.com"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Test Buttons */}
            <div className="flex space-x-4">
              <button
                onClick={testJoinRequestEmail}
                disabled={loading}
                className="bg-green-600 text-white px-6 py-3 rounded hover:bg-green-700 disabled:opacity-50"
              >
                {loading ? 'Test en cours...' : 'Test Email Adhésion (via API)'}
              </button>

              <button
                onClick={testBrevoService}
                disabled={loading}
                className="bg-purple-600 text-white px-6 py-3 rounded hover:bg-purple-700 disabled:opacity-50"
              >
                {loading ? 'Test en cours...' : 'Test Resend Direct'}
              </button>
            </div>

            {/* Result Display */}
            {result && (
              <div className={`p-4 rounded-lg ${
                result.success ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'
              }`}>
                <h3 className={`font-semibold ${
                  result.success ? 'text-green-900' : 'text-red-900'
                }`}>
                  {result.success ? '✅ Succès' : '❌ Erreur'}
                </h3>
                <pre className={`mt-2 text-sm ${
                  result.success ? 'text-green-800' : 'text-red-800'
                }`}>
                  {JSON.stringify(result, null, 2)}
                </pre>
              </div>
            )}

            {/* Instructions */}
            <div className="bg-yellow-50 p-4 rounded-lg">
              <h3 className="font-semibold text-yellow-900 mb-2">Instructions</h3>
              <ul className="text-sm text-yellow-800 space-y-1">
                <li>1. Vérifiez d'abord la configuration</li>
                <li>2. Entrez votre email de test</li>
                <li>3. Testez l'email via l'API complète</li>
                <li>4. Si ça ne marche pas, testez Resend directement</li>
                <li>5. Consultez la console pour les logs détaillés</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
